import {createContext, type PropsWithChildren, use, useMemo} from 'react'

export type Counts = {
  numberOfEnabledRulesets: number
  numberOfEnabledPreviews: number
}

export const CountsContext = createContext<Counts | undefined>(undefined)

export function CountsProvider({
  children,
  numberOfEnabledRulesets,
  numberOfEnabledPreviews,
}: PropsWithChildren<Counts>) {
  const value = useMemo(
    () => ({numberOfEnabledRulesets, numberOfEnabledPreviews}),
    [numberOfEnabledRulesets, numberOfEnabledPreviews],
  )

  return <CountsContext value={value}>{children}</CountsContext>
}

export function useCounts() {
  const context = use(CountsContext)
  if (!context) {
    throw new Error('useCounts must be used within a CountsProvider')
  }
  return context
}
